import { Select } from '@packages/uiKit/Select';

import styled from 'styled-components';

export const StyledLangSelect = styled(Select)`
  min-width: 250px;
` as typeof Select;
